import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { toast } from "sonner";
import { ApiError } from "./http";

type AppMeta = { suppressGlobalError?: boolean };

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (error, query) => {
            if ((query.meta as AppMeta | undefined)?.suppressGlobalError) {
                return;
            }
            const message =
                error instanceof ApiError
                    ? error.message
                    : "Failed to load data. Please try again.";
            toast.error(message);
        },
    }),
    mutationCache: new MutationCache({
        onError: (error, _vars, _ctx, mutation) => {
            if ((mutation.options.meta as AppMeta | undefined)?.suppressGlobalError) {
                return;
            }
            const message =
                error instanceof ApiError ? error.message : "Operation failed. Please try again.";
            toast.error(message);
        },
    }),
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            retry: 1,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: 0,
        },
    },
});
